import React from "react";
import { useNavigationState } from "@react-navigation/native";
import { navigationService } from "./navigationService";

export const NavigationState = () => {
    const state = useNavigationState((state) => state);


    React.useEffect(() => {
        // useNavigationState
        navigationService.setState(state);
    })
    
    return null;
}